import { render } from "./InstantSearch.vue?vue&type=template&id=6d763b5c"
import script from "./InstantSearch.vue?vue&type=script&lang=js"
export * from "./InstantSearch.vue?vue&type=script&lang=js"

import "./InstantSearch.vue?vue&type=style&index=0&id=6d763b5c&lang=css"
script.render = render

export default script